import track from 'react-tracking';
import { RouterLink } from '@redux-first-router-link';

interface Props {
  name: string;
  index: number;
  expiryTime: string;
  uniqueSymbol: string;
  canonicalUrl: string;
  handleClick?: () => void;
}

const ViewedCompaniesItem = ({
  index,
  expiryTime,
  uniqueSymbol,
  canonicalUrl,
  handleClick,
  tracking: { trackEvent },
}: Props & Tracking) => (
  <tr>
    <td>{uniqueSymbol}</td>
    <td>{expiryTime}</td>
    <td>
      <RouterLink
        to={canonicalUrl}
        onClick={() => {
          handleClick && handleClick();
          trackEvent({
            modifier: 'view',
            index: index,
            uniqueSymbol,
          });
        }}
        inheritColor
      >
        View
      </RouterLink>
    </td>
  </tr>
);

export default track({
  type: 'track',
  action: 'click',
})(ViewedCompaniesItem);
